module.exports = __webpack_public_path__ + "static/media/fem_11.73480991.png";